import React, { useContext } from 'react';
import Rupee from '../../../Assets/Modals/RupeeGray.svg';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';
import { sanitizeToPositiveInteger } from '../../../lib/utils/utils';

function PurchaseRequirement() {
    const { formInputs, setFormInputs, purchaseRequirement, setPurchaseRequirement, formErrors } = useContext(AddCouponFormContext);

    const handleOptionChange = (event) => {
        setPurchaseRequirement(event.target.value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const cleanedValue = sanitizeToPositiveInteger(value);
        setFormInputs({ ...formInputs, [name]: cleanedValue });
    };

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Minimum Order Value</h1>
            
                <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.purchaseAmount}</p>
            </div>

            <div className="flex flex-col gap-2 w-fit">
                <div className="flex items-center gap-2">
                    <label htmlFor='purchase-required-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${purchaseRequirement === 'purchase-required' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                purchaseRequirement === 'purchase-required' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>

                    <label htmlFor="purchase-required-radio" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none'>
                        <input 
                            id='purchase-required-radio'
                            value='purchase-required' 
                            type="radio" 
                            checked={purchaseRequirement === 'purchase-required'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        MOV required (Coupon will only apply if the order value is equal to or greater than MOV)
                    </label>
                </div>

                {
                    purchaseRequirement === 'purchase-required' && 
                    <div className="ml-8 border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg w-[200px] h-14 flex items-center gap-2 focus-within:border-primaryColor">
                        <div className="size-6 flex items-center justify-center">
                            <img src={Rupee} alt="" />
                        </div>

                        <input 
                            name='purchaseAmount' 
                            className='w-[calc(100%-24px)] bg-transparent outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666]' 
                            type="text" 
                            placeholder='0.00' 
                            value={formInputs.purchaseAmount} 
                            onChange={handleChange} 
                        />
                    </div>
                }

                <div className="flex items-center gap-2">
                    <label htmlFor='purchase-not-required-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${purchaseRequirement === 'purchase-not-required' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                purchaseRequirement === 'purchase-not-required' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>

                    <label htmlFor="purchase-not-required-radio" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none'>
                        <input 
                            id='purchase-not-required-radio'
                            value='purchase-not-required' 
                            type="radio" 
                            checked={purchaseRequirement === 'purchase-not-required'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        No MOV required (Discount is calculated proportionally until it hits the cap -if cap exists)
                    </label>
                </div>
            </div>
        </div>
    );
}

export default PurchaseRequirement;
